type Finding = { id?: unknown; value?: { found?: unknown } };
type Assessment = {
  tool?: { name?: unknown };
  host?: { computer_name?: unknown };
  run?: { finished_at?: unknown };
  findings?: unknown;
};

export interface AssessmentPc {
  name: string;
  checkedAt: string | null;
  crowdStrike: 'attivo' | 'rilevato' | 'non rilevato' | 'non verificato';
}

export function assessmentPc(raw: unknown): AssessmentPc | null {
  if (!raw || typeof raw !== 'object') return null;
  const report = raw as Assessment;
  if (report.tool?.name !== 'nis2-check' || typeof report.host?.computer_name !== 'string') return null;
  const name = report.host.computer_name.trim().toUpperCase();
  if (!/^[A-Z0-9][A-Z0-9._-]{0,79}$/.test(name)) return null;
  const findings = Array.isArray(report.findings) ? report.findings as Finding[] : [];
  const edr = findings.find((finding) => finding.id === 'pc.protection.edr');
  const found = Array.isArray(edr?.value?.found) ? edr.value.found as Array<{ label?: unknown; evidence?: unknown }> : [];
  const crowdStrike = found.find((item) => item.label === 'CrowdStrike Falcon');
  const evidence = Array.isArray(crowdStrike?.evidence) ? crowdStrike.evidence as Array<{ name?: unknown; state?: unknown }> : [];
  const active = evidence.some((item) => item.name === 'CSFalconService' && item.state === 'Running');
  const checkedAt = typeof report.run?.finished_at === 'string' && !Number.isNaN(Date.parse(report.run.finished_at))
    ? report.run.finished_at : null;
  return { name, checkedAt, crowdStrike: !edr ? 'non verificato' : active ? 'attivo' : crowdStrike ? 'rilevato' : 'non rilevato' };
}
